<script setup lang="ts">
import { ref } from 'vue'
import PDataTable from 'primevue/datatable'
import PColumn from 'primevue/column'

interface AsmeB401Accuracy {
  grade: string
  lower: string | null
  middle: string | null
  upper: string | null
  test_points: string
}

const columns = ref([
  { field: 'grade', header: 'Grade' },
  { field: 'lower', header: 'Lower 25%' },
  { field: 'middle', header: 'Middle 50%' },
  { field: 'upper', header: 'Upper 25%' },
  { field: 'test_points', header: 'Min Rec. # of Test Points' }
])

const asmeB401 = ref<AsmeB401Accuracy[]>([
  {
    grade: '4A',
    lower: '0.10',
    middle: null,
    upper: null,
    test_points: '10'
  },
  {
    grade: '3A',
    lower: '0.25',
    middle: null,
    upper: null,
    test_points: '5'
  },
  {
    grade: '2A',
    lower: '0.50',
    middle: null,
    upper: null,
    test_points: '5'
  },
  {
    grade: '1A',
    lower: '1.00',
    middle: null,
    upper: null,
    test_points: '5'
  },
  {
    grade: 'A',
    lower: '±2',
    middle: '±1',
    upper: '±2',
    test_points: '5'
  },
  {
    grade: 'B',
    lower: '±3',
    middle: '±2',
    upper: '±3',
    test_points: '3'
  }
])
</script>

<template>
  <div class="mb-4">
    <h3 class="m-0 text-3xl">
      ASME B40.1
    </h3>
    <span class="block">
      Accuracy for Pressure Indicating Dial Type, Elastic Element Gauges
    </span>
  </div>
  <p-data-table
    :value="asmeB401"
    class="border-1 border-200"
  >
    <p-column
      v-for="col in columns"
      :key="col.field"
      :field="col.field"
      :header="col.header"
    />
    <template #footer>
      <div class="text-sm font-italic">
        * The test points shall be distributed over the dial range and shall include points within 10% of the ends of the dial range.
      </div>
    </template>
  </p-data-table>
</template>
